<dashboardnav>
    <cradua-activity-status
    [activitystatuss]="activitystatuss$ | async"
    (activitystatus)="onSubmitActivityStatus($event)"
    (deleteActivityStatusEvent)="onDeleteActivityStatus($event)"
    *ngIf="(isLoadingActivityStatus$ | async ) === false"
    >
  </cradua-activity-status>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingActivityStatus$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
